var exports = {
  "lI": "DateOfBirthField.module__fieldset___RGU4dl",
  "_A": "DateOfBirthField.module__labelContainer___RGU4dl",
  "o1": "DateOfBirthField.module__legend___RGU4dl",
  "$K": "DateOfBirthField.module__inputsContainer___RGU4dl",
  "EN": "DateOfBirthField.module__fieldsRow___RGU4dl",
  "tZ": "DateOfBirthField.module__monthField___RGU4dl",
  "bc": "DateOfBirthField.module__dayField___RGU4dl",
  "Y9": "DateOfBirthField.module__yearField___RGU4dl",
  "kc": "DateOfBirthField.module__errorText___RGU4dl",
  "Kd": "DateOfBirthField.module__nativeDateInput___RGU4dl",
};

module.exports = exports;
